import { Button } from '@/components/ButtonComponent';
import { Text } from '@/components/TextComponent';
import { Box } from '@/components/lib/components';
import { isAndroid, isIos } from '@/utils/constants-platform-specific';
import { HapticFeedbackTypes, triggerHapticFeedback } from '@/utils/haptic-feedback';

type Support = { ios: boolean; android: boolean };

const SUPPORT: Record<HapticFeedbackTypes, Support> = {
    // ✅ Cross-platform
    impactLight: { ios: true, android: true },
    impactMedium: { ios: true, android: true },
    impactHeavy: { ios: true, android: true },
    rigid: { ios: true, android: true },
    soft: { ios: true, android: true },
    notificationSuccess: { ios: true, android: true },
    notificationWarning: { ios: true, android: true },
    notificationError: { ios: true, android: true },

    //  iOS-only
    selection: { ios: true, android: false },

    // 🤖 Android-only
    clockTick: { ios: false, android: true },
    contextClick: { ios: false, android: true },
    keyboardPress: { ios: false, android: true },
    keyboardRelease: { ios: false, android: true },
    keyboardTap: { ios: false, android: true },
    longPress: { ios: false, android: true },
    textHandleMove: { ios: false, android: true },
    virtualKey: { ios: false, android: true },
    virtualKeyRelease: { ios: false, android: true },
    effectClick: { ios: false, android: true },
    effectDoubleClick: { ios: false, android: true },
    effectHeavyClick: { ios: false, android: true },
    effectTick: { ios: false, android: true },
};

const METHODS = Object.keys(SUPPORT) as HapticFeedbackTypes[];

const iosBadge = (s: Support) => `iOS ${s.ios ? '✅' : '❌'}`;
const androidBadge = (s: Support) => `Android ${s.android ? '✅' : '❌'}`;

const Section = ({ title, items }: { title: string; items: HapticFeedbackTypes[] }) => (
    <Box marginBottom={'s16'}>
        <Text marginBottom={'s8'}>{title}</Text>

        {items.map(type => {
            const s = SUPPORT[type];
            const disabled = (isIos && !s.ios) || (isAndroid && !s.android);

            return (
                <Box key={type} marginBottom={'s8'} opacity={disabled ? 0.4 : 1}>
                    <Button
                        label={`${type} · ${iosBadge(s)} · ${androidBadge(s)}`}
                        onPress={() => triggerHapticFeedback(type)}
                    />
                </Box>
            );
        })}
    </Box>
);

export const HapticDemo = () => {
    const cross = METHODS.filter(t => SUPPORT[t].ios && SUPPORT[t].android);
    const ios = METHODS.filter(t => SUPPORT[t].ios && !SUPPORT[t].android);
    const android = METHODS.filter(t => SUPPORT[t].android && !SUPPORT[t].ios);

    return (
        <Box padding="s16">
            <Section title="✅ Cross-platform (iOS + Android)" items={cross} />
            <Section title=" iOS only" items={ios} />
            <Section title="🤖 Android only" items={android} />
        </Box>
    );
};
